import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";

import styles from "../Profile.module.scss";
import React from "react";
import { useNavigate } from "react-router-dom";
import { RoutingList } from "../../../../constants";

type PasswordSectionProps = {
  dateValue: string;
};

const PasswordSection = (props: PasswordSectionProps) => {
  const { dateValue } = props;
  const navigate = useNavigate();
  return (
    <Card className={`mg-b-20`}>
      <CardContent className={`pd-x-30 pd-y-24`}>
        <div
          className={`d-flex align-items-start justify-content-between mg-b-30`}
        >
          <div>
            <Typography variant={"h1"} component={"h1"}>
              Profile Info
            </Typography>
            <Typography variant={"body1"} component={"p"} color={"secondary"}>
              A secure password helps protect your account
            </Typography>
          </div>
          <Button
            variant={"outlined"}
            color={"error"}
            className="mg-r-10 btn-sm"
            type="button"
            onClick={() => navigate(RoutingList.profile.password.path)}
          >
            Change password
          </Button>
        </div>
        <Grid className="align-items-center" container spacing={1}>
          <Grid item xs={12} md={3}>
            <Box>
              <Box className={styles.dots}></Box>
              <Box className={styles.dots}></Box>
              <Box className={styles.dots}></Box>
              <Box className={styles.dots}></Box>
              <Box className={styles.dots}></Box>
              <Box className={styles.dots}></Box>
              <Box className={styles.dots}></Box>
              <Box className={styles.dots}></Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography className={styles.textPrimary}>
              Last changed {dateValue}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default PasswordSection;
